import { Button, Modal, Toast, ToastContainer } from "react-bootstrap"
import useUXStore from "../api/ux/store"

const Dialogs = () => {
    const { dialogs, toasts, hideToast } = useUXStore(state => state)
    //console.log(toasts
    return (
        <>
            {
                Array.from(dialogs.entries()).map(([key, value]) => {
                    return (
                        <Modal dialogClassName={value.className} key={key} show={value.visible} onHide={value.onClose}>
                            <Modal.Header closeButton>
                                {value.title && <Modal.Title>{value.title}</Modal.Title>}
                            </Modal.Header>
                            <Modal.Body>
                                {value.content}
                            </Modal.Body>
                            {value.onConfirm && <Modal.Footer>
                                <Button disabled={!value.confirmActive} onClick={value.onConfirm}>
                                    {value.confirmContent}
                                </Button>
                            </Modal.Footer>}
                        </Modal>
                    )
                })
            }
            <ToastContainer className="p-3 fixed-toast" position="top-end">
                {toasts.map((toast, i) => (
                    <Toast key={i + "toast"} bg={toast.Type ? toast.Type! : ""}
                        show={toast.Visible}
                        onClose={() => hideToast(toast.Id)}
                        delay={4000} autohide>
                        {toast.Title !== "" && <Toast.Header>
                            <strong className="me-auto">{toast.Title}</strong>
                        </Toast.Header>}
                        <Toast.Body className="text-dark">{toast.Msg}</Toast.Body>
                    </Toast>))}
            </ToastContainer>
        </>
    )
}

export default Dialogs